import React from 'react';
const PinkboxSkeleton = () => {
  return <div className='my-2 flex items-center gap-3' data-sentry-component="PinkboxSkeleton" data-sentry-source-file="pinkbox-skeleton.tsx">
            <div className='flex flex-[3] items-center gap-3'>
                <div className='h-10 w-[50%] animate-pulse rounded bg-white'></div>
                <div className='h-10 w-[40%] animate-pulse rounded bg-white'></div>
            </div>
            <div className='flex flex-[2] items-center justify-end pl-2'>
                <div className='h-10 w-[70%] animate-pulse rounded bg-white'></div>
            </div>
        </div>;
};
export default PinkboxSkeleton;